import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SEO from "./components/SEO";
import Pdf from "./components/Pdf";
import Whatsapp from "./components/Whatsapp";
import TermsandConditions from "./components/TermsandConditions";
import { shouldRedirectToDomain } from "./utils/domainRouter";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Blogs from "./pages/Blogs";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Rooms from "./pages/Rooms";
import Ayurveda from "./pages/Ayurveda";
import Yoga from "./pages/Yoga";
import Food from "./pages/Food";
import Events from "./pages/Events";
import Tours from "./pages/Tours";
import DeluxeRoom from "./pages/DeluxeRoom";

import Search from "./BookingBeach/Search";
import Booking from "./BookingBeach/Booking";
import Checkout from "./BookingBeach/Checkout";
import Confirmation from "./BookingBeach/Confirmation";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname || '/';

  // Handle domain-based routing on mount and route changes
  useEffect(() => {
    // Check if we need to redirect to a different domain
    const redirectUrl = shouldRedirectToDomain();
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    // Auto-redirect root to home
    if (path === '/') {
      navigate('/home', { replace: true });
    }
  }, [path, navigate]);

  // More powerful, keyword-optimized, route-specific SEO
  let seoProps = { pathname: path };

  if (path.includes('deluxe')) {
    seoProps = {
      ...seoProps,
      title: 'Deluxe Room with Sea View – Mahi Beach Ayurveda Resort Maggona',
      description: 'Experience our exclusive Deluxe Room with Sea View featuring traditional Ayurveda therapies, beachfront yoga, Panchakarma detox, herbal treatments and oceanfront relaxation at Mahi Beach Ayurveda Resort in Maggona, Sri Lanka. Book your wellness holiday now.',
      keywords: 'deluxe sea view room maggona, ayurveda accommodation sri lanka, beach resort rooms maggona, mahi beach rooms, ayurveda resort accommodation',
      url: 'https://mahibeachayurveda.com/rooms/deluxe',
    };
  } else if (path.includes('ayurveda')) {
    seoProps = {
      ...seoProps,
      title: 'Ayurveda Treatments – Mahi Beach Ayurveda Resort Maggona',
      description: 'Authentic Ayurveda treatments and Panchakarma therapy at Mahi Beach Ayurveda Resort. Traditional healing therapies, Abhyanga massage, detox programs in Maggona, Sri Lanka.',
      keywords: 'ayurveda treatments maggona, panchakarma sri lanka, ayurveda therapy beach resort, traditional ayurveda maggona',
      url: 'https://mahibeachayurveda.com/ayurveda',
    };
  } else if (path.includes('yoga')) {
    seoProps = {
      ...seoProps,
      title: 'Yoga & Meditation – Mahi Beach Ayurveda Resort Maggona',
      description: 'Daily yoga and meditation sessions by the beach at Mahi Beach Ayurveda Resort. Experience holistic wellness with expert yoga instructors in Maggona, Sri Lanka.',
      keywords: 'beach yoga maggona, yoga retreat sri lanka, meditation beach resort, wellness yoga maggona',
      url: 'https://mahibeachayurveda.com/yoga',
    };
  } else if (path.includes('rooms')) {
    seoProps = {
      ...seoProps,
      title: 'Accommodation – Mahi Beach Ayurveda Resort Maggona Sri Lanka',
      description: 'Deluxe sea view rooms with modern amenities and Ayurvedic comfort at Mahi Beach Ayurveda Resort. Beachfront accommodation in Maggona with stunning ocean views.',
      keywords: 'sea view rooms maggona, beach resort accommodation sri lanka, deluxe rooms maggona, ayurveda resort rooms',
      url: 'https://mahibeachayurveda.com/rooms',
    };
  } else if (path.includes('about')) {
    seoProps = {
      ...seoProps,
      title: 'About Us – Mahi Beach Ayurveda Resort Maggona',
      description: 'Learn about Mahi Beach Ayurveda Resort, your premier destination for authentic Ayurveda wellness and beachfront healing in Maggona, Sri Lanka.',
      keywords: 'mahi beach ayurveda resort, ayurveda resort maggona, authentic ayurveda sri lanka',
      url: 'https://mahibeachayurveda.com/about-us',
    };
  } else if (path.includes('contact')) {
    seoProps = {
      ...seoProps,
      title: 'Contact Us – Mahi Beach Ayurveda Resort Maggona',
      description: 'Contact Mahi Beach Ayurveda Resort for reservations and inquiries. Located in Maggona, Sri Lanka. Phone: +94 77 738 2466',
      keywords: 'contact mahi beach ayurveda, book ayurveda resort maggona, mahi beach reservations',
      url: 'https://mahibeachayurveda.com/contact-us',
    };
  } else {
    seoProps = {
      ...seoProps,
      title: 'Mahi Beach Ayurveda Resort — Premier Beachfront Ayurveda Resort in Maggona, Sri Lanka',
      description: 'Experience authentic Ayurveda healing in Sri Lanka at Mahi Beach Ayurveda Resort: beachfront wellness in Maggona. Traditional treatments, Panchakarma, yoga, detox, organic food & sea view rooms.',
      keywords: 'mahi beach ayurveda resort, ayurveda resort maggona, ayurveda sri lanka, panchakarma sri lanka, wellness retreat maggona, beach ayurveda resort, best ayurveda resort sri lanka',
      url: 'https://mahibeachayurveda.com',
    };
  }

  return (
    <div>
      <SEO {...seoProps} />
      <Pdf />
      <Whatsapp />
      <TermsandConditions />
      <Navbar />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/ayurveda" element={<Ayurveda />} />
        <Route path="/yoga" element={<Yoga />} />
        <Route path="/food" element={<Food />} />
        <Route path="/events" element={<Events />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/rooms/deluxe" element={<DeluxeRoom />} />


        <Route
          path="/search"
          element={<Search />}
        />
        <Route
          path="/booking"
          element={<Booking />}
        />
        <Route
          path="/checkout"
          element={<Checkout />}
        />
        <Route
          path="/confirmation"
          element={<Confirmation />}
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
